import EntityServise from "./entityService";
import http from '../util/ws/wsService.js'

class ItemService extends EntityServise {
    constructor() {
        super("item")
    }


    async getByIds(ids) {
        return await http.get(this.routeApi + '/s-ids', { ids: ids == null ? '' : ids.toString() })
    }
}

export default new ItemService();